import React, { useState, useEffect, useRef } from 'react'
import { DirectUpload } from '@rails/activestorage';
import Select from 'react-select'
import { HTTP } from '../../api/resources'
import UserAvater from '../Avatar/UserAvatar';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';
import { set } from 'lodash';

function ManagerForm(props) {
    const [manager, setManager] = useState(props.manager)
    const [isDirty, setDirty] = useState(false)
    const [saving, setSaving] = useState(false)
    const [fileUploading, setFileUploading] = useState(false)
    const [profileImage, setProfileImage] = useState([])
    const [managerOptions, setManagerOptions] = useState([
        {id: 1, name: "Assistant Manager"},
        {id: 2, name: "Project Manager"},
        {id: 3, name: "Project Coordinator"},
        {id: 4, name: "Sponsorship Manager"}
    ])
    const [selectedOption, setSelectedOption] = useState(null)
    const [selectedDelegateNotification, setSelectedDelegateNotification] = useState([])
    const [delegateNotificationOptions, setDelegateNotificationOptions] = useState([])
    const [editDelegateNotification, setEditDelegateNotification] = useState(false)
    const [sponsorshipManagerPermissionOptions, setSponsorshipManagerPermissionOptions] = useState([])
    const [projectManagerPermissionOptions, setProjectManagerPermissionOptions] = useState([])
    const [sponsorManagerPermissions, setSponsorshipManagerPermissions] = useState([])
    const [projectManagerPermissions, setProjectManagerPermissions] = useState([])
    let platformManager = props.manager
    let currentUser = props.user
    let image = null
    const isNew = props.new
    const canGivePermissions = currentUser.user_type == 'manager' || currentUser.user_type == 'assistant_manager'

    useEffect(() => {
        if (platformManager && platformManager.user_type != 'manager') {
            if (platformManager.user_type == 'assistant_manager') setSelectedOption(managerOptions[0])
            if (platformManager.user_type == 'project_manager') setSelectedOption(managerOptions[1])
            if (platformManager.user_type == 'project_coordinator') setSelectedOption(managerOptions[2])
            if (platformManager.user_type == 'sponsorship_manager') setSelectedOption(managerOptions[3])
        }

        if (props.user.user_type == 'assistant_manager') {
            setManagerOptions([
                {id: 2, name: "Project Manager"},
                {id: 3, name: "Project Coordinator"},
                {id: 4, name: "Sponsorship Manager"}
            ])
        }

        if (props.sponsorship_manager_permissions && props.sponsorship_manager_permissions.length > 0) {
            setSponsorshipManagerPermissionOptions(props.sponsorship_manager_permissions.map(permission => {
                if (permission == 'donor_post_approval') {
                    return {
                        id: permission,
                        name: `${props.team.donor_title} Post Approval`
                    }
                }

                if (permission == 'beneficiary_post_approval') {
                    return {
                        id: permission,
                        name: `${props.team.beneficiary_title} Post Approval`
                    }
                }

                return {
                    id: permission,
                    name: permission.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
                }
            }))
            setSponsorshipManagerPermissions(manager.sponsorship_manager_permissions.map(permission => {
                if (permission == 'donor_post_approval') {
                    return {
                        id: permission,
                        name: `${props.team.donor_title} Post Approval`
                    }
                }

                if (permission == 'beneficiary_post_approval') {
                    return {
                        id: permission,
                        name: `${props.team.beneficiary_title} Post Approval`
                    }
                }

                return {
                    id: permission,
                    name: permission.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
                }
            }))
        }

        if (props.project_manager_permissions && props.project_manager_permissions.length > 0) {
            setProjectManagerPermissionOptions(props.project_manager_permissions.map(permission => {
                if (permission == 'sponsor_management') {
                    return {
                        id: permission,
                        name: `${props.team.donor_title} Management`
                    }
                }

                return {
                    id: permission,
                    name: permission.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
                }
            }))
            setProjectManagerPermissions(manager.project_manager_permissions.map(permission => {
                if (permission == 'sponsor_management') {
                    return {
                        id: permission,
                        name: `${props.team.donor_title} Management`
                    }
                }
                
                return {
                    id: permission,
                    name: permission.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
                }
            }))
        }
    }, [])

    useEffect(() => {
        // decide if manager is the one delegating
        if (currentUser.user_type == 'manager') {
            setEditDelegateNotification(true)
        }

        if (currentUser.user_type == 'assistant_manager' && platformManager.user_type !== 'assistant_manager') {
            setEditDelegateNotification(true)
        }

        // decide select options for delegate notification
        if (platformManager.user_type == 'assistant_manager') {
            let array = [
                {id: 'billing_notification', name: 'Billing Notification'},
                {id: 'posts_pending_approval_notification', name: 'Posts Pending Approval Notification'},
                {id: 'sponsorship_notification', name: 'Sponsorship Notification'},
                {id: 'import_notification', name: 'Import Notification'},
            ]
            setDelegateNotificationOptions(array)
            if (platformManager.admin_billing_notifications_enabled) {
                setSelectedDelegateNotification(selectedDelegateNotification => ([...selectedDelegateNotification, array[0]]))
            }

            if (platformManager.admin_post_pending_approval_notifications_enabled) {
                setSelectedDelegateNotification(selectedDelegateNotification => ([...selectedDelegateNotification, array[1]]))
            }

            if (platformManager.admin_sponsorship_notifications_enabled) {
                setSelectedDelegateNotification(selectedDelegateNotification => ([...selectedDelegateNotification, array[2]]))
            }

            if (platformManager.admin_import_notifications_enabled) {
                setSelectedDelegateNotification(selectedDelegateNotification => ([...selectedDelegateNotification, array[3]]))
            }
        }

        if (platformManager.user_type !== 'assistant_manager') {
            let array = [
                {id: 'sponsorship_notification', name: 'Sponsorship Notification'},
            ]
            setDelegateNotificationOptions(array)

            if (platformManager.admin_sponsorship_notifications_enabled) {
                setSelectedDelegateNotification(selectedDelegateNotification => ([...selectedDelegateNotification, array[0]]))
            }
        }
    }, [])

    // warning before leaving page
    window.onbeforeunload = (e) => {
        if (isDirty) return ''
    }

    const validate = () => {
        if (!manager.first_name || manager.first_name.length < 1) {
            Alert.show('notice', 'Manager first name is required')
            return
        }

        if (!manager.last_name || manager.last_name.length < 1) {
            Alert.show('notice', 'Manager last name is required')
            return
        }

        if (!manager.email || manager.email.length < 1) {
            Alert.show('notice', 'Manager email is required')
            return
        }

        if (!selectedOption) {
            Alert.show('notice', 'Manager role is required')
            return
        }

        handleSave()
    }

     // Create a lookup object
     const notificationLookup = selectedDelegateNotification.reduce((acc, notification) => {
        acc[notification.id] = true;
        return acc;
    }, {});

    const handleSave = async () => {
        setSaving(true)

        if (!selectedDelegateNotification || selectedDelegateNotification.length < 1) {
            setSelectedDelegateNotification(selectedDelegateNotification => ([]))
        }

        let sponsorshipManagerPermissions = []
        let projectManagerPermission = []
        if ((manager.user_type === 'project_manager' || manager.user_type === 'project_coordinator') && projectManagerPermissions.length > 0) {
            projectManagerPermission = projectManagerPermissions.map(permission => permission.id)
        }
        if (manager.user_type === 'sponsorship_manager' && sponsorManagerPermissions.length > 0) {
            sponsorshipManagerPermissions = sponsorManagerPermissions.map(permission => permission.id)
        }

        let data = {
            manager: {
                first_name: manager.first_name,
                last_name: manager.last_name,
                email: manager.email,
                user_type: selectedOption.name.toLowerCase().replace(' ', '_'),
                username: manager.username,
                avatar_url: manager.avater_url,
                avatar: manager.avater, 
                approve_donor_post: manager.approve_donor_post,
                approve_beneficiary_post: manager.approve_beneficiary_post, 
                subscribed_to_notifications: manager.subscribed_to_notifications,
                notify_of_field_changes: manager.notify_of_field_changes,
                admin_billing_notifications_enabled: !!notificationLookup['billing_notification'],
                admin_post_pending_approval_notifications_enabled: !!notificationLookup['posts_pending_approval_notification'],
                admin_sponsorship_notifications_enabled: !!notificationLookup['sponsorship_notification'],
                admin_import_notifications_enabled: !!notificationLookup['import_notification'],
                sponsorship_manager_permissions: sponsorshipManagerPermissions,
                project_manager_permissions: projectManagerPermission
            }
        }

        // update manager
        if (!props.new) {
            try {
                await updateUser(data)
            } catch (error) {
                if (error.response && error.response.data && error.response.data.error) {
                    Alert.show('error', error.response.data.error);
                } else {
                    Alert.show('error', 'Could not create manager, try again');
                }
                setSaving(false);
                return;
            }

            Alert.show('notice', 'Manager has been updated')
            setSaving(false)
            setDirty(false)
            setTimeout(() => window.location = '/p/users', 1500)
            return
        }

        // create a new manager
        try {
            await createUser(data)
        } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
                Alert.show('error', error.response.data.error);
            } else {
                Alert.show('error', 'Could not create manager, try again');
            }
            setSaving(false);
            return;
        }

        Alert.show('notice', 'Manager has been saved')
        setSaving(false)
        setDirty(false)
        setTimeout(() => window.location = '/p/users', 1500)
    }

    const updateUser = (data) => {
        return HTTP.patch(`/p/users/edit/${platformManager.id}`, data)
    }

    const createUser = (data) => {
        return HTTP.post('/p/users/new', data)
    }

    // upload media
    const hiddenFileInput = React.useRef(null);

    const handleClick = (event) => {
        hiddenFileInput.current.click();
    };

    const handleChange = (event) => {
        setDirty(true)
        const files = event.target.files;
        // upload only the first file
        uploadFile(files[0])
    }

      // upload files to profile avater view
      const uploadFile = (file) => {
        // Check for .jiff extension
        if (file.name.endsWith('.jfif')) {
            Alert.show('error', '.jiff image is not allowed');
            return;
        }
        
        setFileUploading(true)
        const upload = new DirectUpload(file, '/api/v1/direct_uploads');
        upload.create((error, blob) => {
          if (error) {
            // Handle the error
            Alert.show("error", "Could not update. Try again.");
            setFileUploading(false)
          } else {
            setTimeout(() => { setFileUploading(false) }, 5000);
            image = blob
            setManager({...manager, avater_url: image.cdn_url, avater: image.signed_id})
            Alert.show('notice', 'Image has been added')
          }
        })
       }

       const capitalizeEveryWord = (string) => {
        return string
          .split(' ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      };


  return (
    <div>
        {isNew &&
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header d-flex align-items-center justify-content-between">
                    <div>
                        {props.new &&<h4 class="card-title">New User</h4>}
                        {!props.new &&<h4 class="card-title">{`${manager.name}`}</h4>}
                    </div>

                    <div>
                        <a className="btn btn-outline-danger mr-1" href="/p/users">Cancel</a>
                        <button className="btn btn-primary" onClick={validate}>
                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                            Save
                        </button>
                    </div>
                    </div>
                    <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="first_name">First Name</label>
                            <input type="text" className="form-control" placeholder="First Name" id="first_name" value={manager.first_name}
                            onChange={(e) => {
                                let value = e.target.value
                                setManager({...manager, first_name: value})
                                setDirty(true)
                            }}
                            />
                        </div>

                        <div class="form-group">
                            <label htmlFor="email">Email</label>
                            <input type="email" className="form-control" placeholder="Example@domain.com" id="email" value={manager.email}
                            onChange={(e) => {
                                let value = e.target.value
                                setManager({...manager, email: value})
                                setDirty(true)
                            }}
                            />
                        </div>

                        </div>
                        <div class="col-md-6">
                        <div class="form-group">
                            <label htmlFor="last_name">Last Name</label>
                            <input type="text" className="form-control" placeholder="Last Name" id="last_name" value={manager.last_name}
                            onChange={(e) => {
                                let value = e.target.value
                                setManager({...manager, last_name: value})
                                setDirty(true)
                            }}
                            />
                        </div>

                        <div class="form-group">
                            <label htmlFor="manager_role">Select Manager Role</label>
                            <div className="input-group" id="manager_role">
                            {props.new &&
                            <Select
                                className="form-control select-beneficiaries"
                                classNamePrefix="select-beneficiaries"
                                onChange={(type) => setSelectedOption(type)}
                                options={managerOptions}
                                getOptionLabel={(option) =>
                                    `${option.name}`
                                }
                                getOptionValue={(type) => type.id}
                                value={selectedOption}
                            />}
                            {!props.new &&
                                <Select
                                className="form-control select-beneficiaries"
                                classNamePrefix="select-beneficiaries"
                                onChange={(type) => setSelectedOption(type)}
                                options={managerOptions}
                                getOptionLabel={(option) =>
                                    `${option.name}`
                                }
                                getOptionValue={(type) => type.id}
                                value={selectedOption}
                                isDisabled
                                />
                            }
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="row">
                        <div className="col-md-6">
                        <div class="form-group">
                            <label htmlFor="username">Username (Optional)</label>
                            <input type="text" className="form-control" placeholder="Username" id="username" value={manager.username}
                            onChange={(e) => {
                                let value = e.target.value
                                setManager({...manager, username: value})
                                setDirty(true)
                            }}
                            />
                            <small class="form-text text-muted">Will be used for login when feature available.</small>
                        </div>
                        </div>
                        {!props.new &&
                        <div className="col-md-6">
                            <div className="form-group">
                            <label htmlFor="profile_image">Profile Image</label>
                                <div id="profile_image" className="d-flex align-items-center">
                                    {<div className="avatar-sm d-inline-block mr-2">
                                        <UserAvater url={manager.avatar_url} fallback={manager.first_name} />
                                    </div>}

                                    <button onClick={handleClick} className="btn btn-primary">
                                    {fileUploading && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                                        Upload Image
                                    </button>
                                </div>
                                <input
                                    type="file"
                                    ref={hiddenFileInput}
                                    style={{ display: "none" }}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
            </div>
        </div>
        }

        {!isNew &&
            <div>
                <div className='card'>
                    <div class="card-header d-flex align-items-center justify-content-between mobile-card-header">
                        <div>
                            <h4 class="card-title">Editing { capitalizeEveryWord(props.profile_type) } Profile
                            </h4>
                        </div>
                        <div>
                            <a class="btn btn-outline-danger mr-1" href="/p/users">Cancel</a>
                            <button onClick={validate} name="button" type="submit" class="btn btn-primary">
                                {saving && <i class="fa fa-spinner-third fa-spin mr-2"></i>}
                                Save
                            </button>
                        </div>
                    </div>

                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="first_name">First Name</label>
                                    <input type="text" className="form-control" placeholder="First Name" id="first_name" value={manager.first_name}
                                    onChange={(e) => {
                                        let value = e.target.value
                                        setManager({...manager, first_name: value})
                                        setDirty(true)
                                    }}
                                    />
                                </div>

                                <div class="form-group">
                                    <label htmlFor="last_name">Last Name</label>
                                    <input type="text" className="form-control" placeholder="Last Name" id="last_name" value={manager.last_name}
                                    onChange={(e) => {
                                        let value = e.target.value
                                        setManager({...manager, last_name: value})
                                        setDirty(true)
                                    }}
                                    />
                                </div>

                                <div class="form-group">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" className="form-control" placeholder="Example@domain.com" id="email" value={manager.email}
                                    onChange={(e) => {
                                        let value = e.target.value
                                        setManager({...manager, email: value})
                                        setDirty(true)
                                    }}
                                    />
                                </div>

                                <div class="form-group">
                                    <label htmlFor="username">Username</label>
                                    <input type="text" className="form-control" placeholder="Username" id="username" value={manager.username}
                                    onChange={(e) => {
                                        let value = e.target.value
                                        setManager({...manager, username: value})
                                        setDirty(true)
                                    }}
                                    />
                                    <small class="form-text text-muted">Will be used for login when feature available.</small>
                                </div>

                                <div class="form-group">
                                    <label htmlFor="manager_role">Select Manager Role</label>
                                    <div className="input-group" id="manager_role">
                                    {props.new &&
                                    <Select
                                        className="form-control select-beneficiaries"
                                        classNamePrefix="select-beneficiaries"
                                        onChange={(type) => setSelectedOption(type)}
                                        options={managerOptions}
                                        getOptionLabel={(option) =>
                                            `${option.name}`
                                        }
                                        getOptionValue={(type) => type.id}
                                        value={selectedOption}
                                    />}
                                    {!props.new &&
                                        <Select
                                        className="form-control select-beneficiaries"
                                        classNamePrefix="select-beneficiaries"
                                        onChange={(type) => setSelectedOption(type)}
                                        options={managerOptions}
                                        getOptionLabel={(option) =>
                                            `${option.name}`
                                        }
                                        getOptionValue={(type) => type.id}
                                        value={selectedOption}
                                        isDisabled
                                        />
                                    }
                                    </div>
                                </div>

                                <div className='form-group'>
                                    <label>Delegate Notifications</label>
                                    <div className="input-group" id="manager_role">
                                        {editDelegateNotification && !props.new &&
                                            <Select
                                                className="form-control delegate-notification"
                                                classNamePrefix="delegate-notification"
                                                onChange={(type) => setSelectedDelegateNotification(type)}
                                                options={delegateNotificationOptions}
                                                getOptionLabel={(option) =>
                                                    `${option.name}`
                                                }
                                                getOptionValue={(type) => type.id}
                                                value={selectedDelegateNotification}
                                                isMulti
                                            />
                                        }
                                        {!editDelegateNotification && !props.new &&
                                            <Select
                                                className="form-control delegate-notification"
                                                classNamePrefix="delegate-notification"
                                                onChange={(type) => setSelectedDelegateNotification(type)}
                                                options={delegateNotificationOptions}
                                                getOptionLabel={(option) =>
                                                    `${option.name}`
                                                }
                                                getOptionValue={(type) => type.id}
                                                value={selectedDelegateNotification}
                                                isDisabled
                                                isMulti
                                            />
                                        }
                                    </div>
                                    {manager.user_type == 'assistant_manager' && 
                                        <small class="form-text text-muted">This user will receive all emails that are in the category of the system admin notifications delegated to them.</small>
                                    }
                                    {manager.user_type !== 'assistant_manager' &&
                                        <small class="form-text text-muted">This user will receive emails relevant to their role that are in the category of the system admin notification delegated to them.</small>
                                    }
                                </div>

                                {/* permissions of actions a sponsorship manager can take */}
                                {manager.user_type === 'sponsorship_manager' &&
                                    <div className='form-group'>
                                        <label>Manager Permissions</label>
                                        <div className="input-group" id="manager_role">
                                            {canGivePermissions && !props.new &&
                                                <Select
                                                    className="form-control manager_permissions"
                                                    classNamePrefix="manager_permissions"
                                                    onChange={(type) => setSponsorshipManagerPermissions(type)}
                                                    options={sponsorshipManagerPermissionOptions}
                                                    getOptionLabel={(option) =>
                                                        `${option.name}`
                                                    }
                                                    getOptionValue={(type) => type.id}
                                                    value={sponsorManagerPermissions}
                                                    isMulti
                                                />
                                            }
                                            {!canGivePermissions && !props.new &&
                                                <Select
                                                    className="form-control manager_permissions"
                                                    classNamePrefix="manager_permissions"
                                                    onChange={(type) => setSponsorshipManagerPermissions(type)}
                                                    options={sponsorshipManagerPermissionOptions}
                                                    getOptionLabel={(option) =>
                                                        `${option.name}`
                                                    }
                                                    getOptionValue={(type) => type.id}
                                                    value={sponsorManagerPermissions}
                                                    isDisabled
                                                    isMulti
                                                />
                                            }
                                        </div>
                                        <small class="form-text text-muted">This user will be able to create, edit and delete if permissions are delegated to them.</small>
                                    </div>
                                }

                                {/* permissions of actions a project manager or coordinator can take */}
                                {(manager.user_type === 'project_manager' || manager.user_type === 'project_coordinator') &&
                                    <div className='form-group'>
                                        <label>Manager Permissions</label>
                                        <div className="input-group" id="manager_role">
                                            {canGivePermissions && !props.new &&
                                                <Select
                                                    className="form-control manager_permissions"
                                                    classNamePrefix="manager_permissions"
                                                    onChange={(type) => setProjectManagerPermissions(type)}
                                                    options={projectManagerPermissionOptions}
                                                    getOptionLabel={(option) =>
                                                        `${option.name}`
                                                    }
                                                    getOptionValue={(type) => type.id}
                                                    value={projectManagerPermissions}
                                                    isMulti
                                                />
                                            }
                                            {!canGivePermissions && !props.new &&
                                                <Select
                                                    className="form-control manager_permissions"
                                                    classNamePrefix="manager_permissions"
                                                    onChange={(type) => setProjectManagerPermissions(type)}
                                                    options={projectManagerPermissionOptions}
                                                    getOptionLabel={(option) =>
                                                        `${option.name}`
                                                    }
                                                    getOptionValue={(type) => type.id}
                                                    value={projectManagerPermissions}
                                                    isDisabled
                                                    isMulti
                                                />
                                            }
                                        </div>
                                        <small class="form-text text-muted">This user will be able to create, edit and delete if permissions are delegated to them.</small>
                                    </div>
                                }
                            </div>

                            <div className="col-md-6">
                                <div className="form-group">
                                <label htmlFor="profile_image">Profile Image</label>
                                    <div id="profile_image" className="d-flex align-items-center">
                                        {<div className="avatar-sm d-inline-block mr-2">
                                            <UserAvater url={manager.avatar_url} fallback={manager.first_name} />
                                        </div>}

                                        <button onClick={handleClick} className="btn btn-primary">
                                        {fileUploading && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                                            Upload Image
                                        </button>
                                    </div>
                                    <input
                                        type="file"
                                        ref={hiddenFileInput}
                                        style={{ display: "none" }}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div class="form-group" style={{ paddingBottom: '5px' }}>
                                    <label>Receive Email Updates</label>
                                    <div class="form-check">
                                    <label class="form-check-label">
                                        <input 
                                            class="form-check-input" type="checkbox" 
                                            checked={manager.subscribed_to_notifications} 
                                            onChange={(event) => setManager({...manager, subscribed_to_notifications: event.target.checked})}
                                        />
                                        <span class="form-check-sign">Keep me updated</span>
                                    </label>
                                    </div>
                                </div>

                                <div class="form-group" style={{ paddingBottom: '5px' }}>
                                    <label>Notify of Field Changes</label>
                                    <div class="form-check">
                                    <label class="form-check-label">
                                        <input 
                                            class="form-check-input" 
                                            type="checkbox" 
                                            checked={manager.notify_of_field_changes} 
                                            onChange={(event) => setManager({...manager, notify_of_field_changes: event.target.checked})}
                                        />
                                        <span class="form-check-sign">Keep me updated</span>
                                    </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

    </div>
  )
}

export default ManagerForm
